import styled from "styled-components";
import { hexToRgba } from "../../../sharable/PickerAndSelector";
import useCestaBasicaKitValorTotal from "./hooks/useCestaBasicaKitValorTotal";
import { useMemo } from "react";
import { calcProductStylesOcurrence } from "../Canvas/CanvasGeneralStyles";

const ValorTotalWrapper = styled.div`
  width: 100%;
  height: min-content;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  gap: ${({ canvasScale = 1 }) => 24 * canvasScale}px;
  margin-bottom: ${({ canvasScale = 1 }) => 24 * canvasScale}px;
  background-color: ${({ headerAndFooterStyles }) =>
    hexToRgba(headerAndFooterStyles?.bgColor, 0.8) || "#111"};
  border: ${({ headerAndFooterStyles, canvasScale = 1 }) =>
    headerAndFooterStyles?.bgColor
      ? `${4 * canvasScale}px solid ${headerAndFooterStyles.bgColor}`
      : "none"};
  border-radius: ${({ canvasScale = 1 }) => 200 * canvasScale}px;
  padding: ${({ canvasScale = 1 }) =>
    `${8 * canvasScale}px ${16 * canvasScale}px`};
  .label {
    text-transform: uppercase;
    font-size: ${({ canvasScale = 1 }) => Math.max(10, 32 * canvasScale)}px;
    line-height: 1;
    font-weight: 500;
  }
  .value {
    font-weight: bold;
    font-size: ${({ canvasScale = 1 }) => Math.max(12, 100 * canvasScale)}px;
    line-height: 1;
  }
  .label,
  .value {
    color: ${({ headerAndFooterStyles }) =>
      headerAndFooterStyles?.txtColor || "#fff"};
  }
`;

export default function CestaBasicKitDisplayPrice({
  label = "Você só paga:",
  products,
  canvasScale = 1,
}) {
  const { kitValorTotal } = useCestaBasicaKitValorTotal(products || []);
  const headerAndFooterStyles = useMemo(
    () => calcProductStylesOcurrence(products),
    [products],
  );

  return (
    <ValorTotalWrapper
      canvasScale={canvasScale}
      headerAndFooterStyles={headerAndFooterStyles}
    >
      <span className="label">{label}</span>
      <span className="value">{kitValorTotal}</span>
    </ValorTotalWrapper>
  );
}
